<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-clipboard-alert"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loading"
      >
        <!-- <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-spacer />
            <v-btn
              elevation="1"
              color="primary"
              dark
              fab
              min-width="0"
              small
              @click="addQuotation"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template> -->
        <!-- <template v-slot:[`item.status`]="{ item }">
          {{ item.status ? "Activo": "Inactivo" }}
        </template> -->
        <template v-slot:[`item.total`]="{ item }">
          {{ "$" + item.total }}
        </template>
        <!-- <template v-slot:[`item.priceSell`]="{ item }">
          {{ "$" + item.priceSell }}
        </template> -->
        <template v-slot:[`item.cardName`]="{ item }">
          <router-link :to="{ name: 'quotation', params: { id: item.id }}">
            {{ item.quotationNumber }}
          </router-link>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="editQuotation(item.id)">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const quotationsRespository = repositoryFactory.get('quotations')

  export default {
    name: 'QuotationList',
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('quotations')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.quotations.number'),
            value: 'quotationNumber',
          },
          {
            text: this.$t('tables.quotations.customer'),
            value: 'customerName',
          },
          {
            text: this.$t('tables.quotations.date'),
            value: 'registerDate',
          },
          {
            text: this.$t('tables.quotations.description'),
            value: 'description',
          },
          {
            text: this.$t('tables.quotations.total'),
            value: 'total',
          },
          {
            text: this.$t('tables.quotations.status'),
            value: 'status',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      var self = this
      self.loading = true
      quotationsRespository.get().then(response => {
        if (response.data.isValid) {
          self.items = response.data.data
        } else {
          self.showErrorMessage = true
          self.errorMessage = response.data.errorMessages[0]
        }
        console.log(response)
        self.loading = false
      }).catch(err => {
        self.showErrorMessage = true
        if (err.response.status === 400) {
          self.errorMessage = err.response.data.errorMessages[0]
        } else {
          self.errorMessage = err
        }
        self.loading = false
      })
    },
    methods: {
      // addQuotation () {
      //   this.$router.push({ name: 'card', params: { id: 'add' } })
      // },
      editQuotation (id) {
        this.$router.push({ name: 'quotation', params: { id: id } })
      },
    },
  }
</script>
